import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="max-w-4xl mx-auto p-8">
      <h1 className="text-3xl font-bold mb-6">Privacy Policy</h1>

      <p className="mb-4">
        Welcome to <strong>[Budget Travel]</strong> (accessible at <strong>[https://budgettravelling.vercel.app]</strong>). 
        Your privacy is very important to us, and this page explains what information we collect and how we use it.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4">Information We Collect</h2>
      <p className="mb-4">
        We may collect personal information that you voluntarily provide to us, such as your name and email address when you subscribe to our newsletter, comment on articles, or contact us.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4">Log Files</h2>
      <p className="mb-4">
        Like many websites, we use log files. These files log visitors when they visit the site. 
        The information collected in log files includes internet protocol (IP) addresses, browser type, internet service provider (ISP), referring/exit pages, and date/time stamps.
        This information is used for analyzing trends, administering the site, and gathering demographic information.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4">Cookies and Web Beacons</h2>
      <p className="mb-4">
        We use cookies to enhance your experience on our website. Cookies help us remember your preferences and understand how you interact with our content.
        You can choose to disable cookies through your individual browser options.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4">Google AdSense</h2>
      <p className="mb-4">
        We display advertisements through Google AdSense. Google may use cookies to serve ads based on a user’s previous visits to our website or other websites.
        You may opt out of personalized advertising by visiting the 
        <a href="https://www.google.com/settings/ads" className="text-blue-500 underline" target="_blank" rel="noopener noreferrer"> Google Ads Settings</a>.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4">Third-Party Links</h2>
      <p className="mb-4">
        Our blog may contain links to external websites that we do not operate. 
        Please be aware that we have no control over the content and practices of these sites and cannot accept responsibility or liability for their respective privacy policies.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4">Consent</h2>
      <p className="mb-4">
        By using our website, you hereby consent to our Privacy Policy and agree to its terms.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4">Updates to This Privacy Policy</h2>
      <p className="mb-4">
        We may update our Privacy Policy from time to time. Any changes will be posted on this page with an updated effective date.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4">Contact Us</h2>
      <p className="mb-4">
        If you have any questions about this Privacy Policy, please feel free to contact us at <strong>
        nomadicrishab9@gmail.com</strong>.
      </p>
    </div>
  );
};

export default PrivacyPolicy;
